import { render, staticRenderFns } from "./auditFailTag.vue?vue&type=template&id=2a06e32c&scoped=true"
import script from "./auditFailTag.vue?vue&type=script&lang=js"
export * from "./auditFailTag.vue?vue&type=script&lang=js"
import style0 from "./auditFailTag.vue?vue&type=style&index=0&id=2a06e32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06e32c",
  null
  
)

export default component.exports